import React from 'react'

const Add = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M24 10H14V0h-4v10H0v4h10v10h4V14h10z" />
  </svg>
)

export default Add
